export default {
  path: '/transaction',
  name: 'transaction',
  redirect: { name: 'transaction.transactions-page' },
  component: () =>
    import(/* webpackChunkName: "transaction" */ '@/views/transactions'),
  children: [
    {
      path: '/transactions',
      name: 'transaction.transactions-page',
      meta: { requiresAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "transactions-page" */ '@/views/transactions/TransactionsPage.vue'
        )
    },
    {
      path: '/transactions/:id',
      name: 'transaction.view-transaction-page',
      meta: { requiresAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "view-transaction-page" */ '@/views/transactions/ViewTransactionPage.vue'
        )
    }
  ]
}
